import Utils from '@/utils/utils';

const SYS = '/rays7';

const HomePage = {
  HOME: SYS + '/ai/productlist',
  LOGIN: '/',
  // HOME: SYS + '/home',
  // LOGIN: '/login',
  META_PERSON: SYS + '/metaperson',
  BOOK: SYS + '/books',
  RESOURCE: SYS + '/resource',
  READERS: SYS + '/readers',
  AI: SYS + '/ai',
  DATA_PANEL: SYS + '/datapanel',
  BASIC: SYS + '/basic'
};

export const PAGES = {
  ...HomePage,
  BOOK_CREATE: HomePage.BOOK + '/create',
  BOOK_MANAGE: HomePage.BOOK + '/manage',
  BOOK_UPDATE: HomePage.BOOK + '/update',
  QRCODE_MANAGE: HomePage.BOOK + '/qrcode',
  BOOK_SELECT: HomePage.BOOK + '/selectBook',
  QRCODE_TYPE_SELECT: HomePage.BOOK + '/selectType',
  BOOK_CREATE_SUCCESS: HomePage.BOOK + '/success',
  BOOK_SCHEME: HomePage.BOOK + '/scheme',
  RESOURCE_APP_CENTER: HomePage.RESOURCE + '/appCenter',
  RESOURCE_MY_APP: HomePage.RESOURCE + '/myApp',
  RESOURCE_MY_PRODUCT: HomePage.RESOURCE + '/myProduct',
  RESOURCE_MATERIAL: HomePage.RESOURCE + '/material',
  RESOURCE_SUPER: HomePage.RESOURCE + '/super',
  RESOURCE_RAYS_TOOLS: HomePage.RESOURCE + '/raysTools',
  META_MONITOR: HomePage.META_PERSON + '/monitor',
  META_VERBAL: HomePage.META_PERSON + '/verbal',
  READER_MANAGE: HomePage.READERS + '/manage',
  READER_MESSAGE: HomePage.READERS + '/message',
  READER_MESSAGE_ADD: HomePage.READERS + '/addmessage',
  READER_FEEDBACK: HomePage.READERS + '/feedback',
  READER_WECHAT: HomePage.READERS + '/wechat',
  AI_TOOLS: HomePage.AI + '/tools',
  AI_HISTORY: HomePage.AI + '/history',
  AI_COPYWRITE: HomePage.AI + '/copywrite',
  AI_SPEEDREADING: HomePage.AI + '/speedReading',
  AI_PAINTING: HomePage.AI + '/painting',
  AI_TEXT2SPEECH: HomePage.AI + '/text2speech',
  DATA_PANEL_OVERVIEW: HomePage.DATA_PANEL + '/overview',
  DATA_PANEL_TRANSACTION: HomePage.DATA_PANEL + '/transaction',
  DATA_PANEL_CONVERSATION: HomePage.DATA_PANEL + '/conversation',
  DATA_PANEL_BOOK_ANALYSIS: HomePage.DATA_PANEL + '/bookanalysis',
  DATA_PANEL_BOOK_DETAIL: HomePage.DATA_PANEL + '/bookdetail',
  DATA_PANEL_DIGITAL_ORDER: HomePage.DATA_PANEL + '/digitalorder',
  BASIC_BOOK_RESEARCH: HomePage.BASIC + '/bookResearch'
};

export const experienceIds = [2084618]; // 预览账号特殊处理

// 获取带params路由
export function getPageUrl(page, params) {
  let url = page;
  Object.keys(params)
    .forEach(key => {
      if(url.indexOf(`:${key}`) > -1) {
        url = url.replace(`:${key}`, params[key]);
        delete params[key];
      }
    });
  return `${url}${Utils.formatQuery2QueryStr(params)}`;
}

export default PAGES;

